import { IconButton } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { MdCallEnd, MdSkipNext, MdVideocam, MdVideocamOff } from 'react-icons/md';
import VyTooltip from '../../../../../common/VyTooltip';

interface SpeedDatingControlBarProps {
  camActive: boolean;
  onToggleCam: () => void;
  onHighlight: () => void;
  onEndClick: () => void;
}
export const SpeedDatingControlBar = (props: SpeedDatingControlBarProps) => {
  const { camActive, onToggleCam, onHighlight, onEndClick } = props;
  const { t } = useTranslation();

  return (
    <div className="flex items-center">
      <VyTooltip title={t('meeting:speeddating.end-tooltip')}>
        <IconButton onClick={onEndClick} size="large">
          <MdCallEnd />
        </IconButton>
      </VyTooltip>
      {/*<VyTooltip title={t('meeting:speeddating.highlight-tooltip')}>
        <IconButton>
          <MdStar />
        </IconButton>
  </VyTooltip>*/}

      <VyTooltip title={t('meeting:speeddating.toggle-cam-tooltip')}>
        <IconButton onClick={onToggleCam} size="large">
          {camActive ? <MdVideocam /> : <MdVideocamOff />}
        </IconButton>
      </VyTooltip>
      <VyTooltip title={t('meeting:speeddating.skip-tooltip')}>
        <IconButton onClick={onEndClick} size="large">
          <MdSkipNext />
        </IconButton>
      </VyTooltip>
    </div>
  );
};
